export const IntroductionRenderer = () => {
    return (
        <div id="introduction-renderer-section">
            <div id="introduction-render" className=""></div>
        </div>
    )
}

export default IntroductionRenderer;